import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { UserPreferencesViewTopBar } from "./TopBar"

export const userPreferencesViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: UserPreferencesViewTopBar,
}
